module.exports = __webpack_public_path__ + "static/media/importFlybook2.a3e775a2.png";